module.exports = __webpack_public_path__ + "img/AVAX.4e9df24e.svg";